const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Build an authenticated absolute URL for a backend file path like "/api/files/..."
export function fileUrl(path) {
  if (!path) return "#";
  const token = localStorage.getItem("access_token") || "";
  const sep = path.includes("?") ? "&" : "?";
  return `${BACKEND_URL}${path}${sep}auth=${encodeURIComponent(token)}`;
}

export function humanSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
